import { render, staticRenderFns } from "./CategoryPracticesList.vue?vue&type=template&id=54b8fd3f&"
import script from "./CategoryPracticesList.vue?vue&type=script&lang=js&"
export * from "./CategoryPracticesList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPracticesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
